import { frontendURL } from '../../../../helper/URLHelper';
import { ensureControlPanelPage } from 'dashboard/composables/masifi/useControlPanelAccess';
import { CONTROL_PANEL_PAGES } from './helpers/controlPanelPages';

// Masifi: Panel de Control (brand-resellers-design.md §4). Registradas vía settings/masifi/masifi.routes.js (ya
// registrado en core) → 0 touchpoints nuevos. Una ruta por fila de CONTROL_PANEL_PAGES. meta.permissions = administrador
// de la cuenta ancla; el guard exige además que /console/me traiga la página (el backend la revalida en cada endpoint).
const meta = { permissions: ['administrator'] };

export const controlPanelRoutes = [
  {
    path: frontendURL('accounts/:accountId/control-panel'),
    redirect: to => ({
      name: 'control_panel_summary',
      params: { accountId: to.params.accountId },
    }),
  },
  ...CONTROL_PANEL_PAGES.map(page => ({
    path: frontendURL(`accounts/:accountId/control-panel/${page.path}`),
    name: page.name,
    component: page.component,
    meta,
    beforeEnter: ensureControlPanelPage(page.key),
  })),
];
